<app-page-title [title]="userDisplayName"></app-page-title>
<div class="container-fluid">
  <div *ngIf="user" class="avatar">
    <app-img-display
      [uid]="user.uid"
      [type]="'userAvatar'"
      [imageTs]="avatarTs"
      [showNoImage]="false"
      [reload]="avatarTs"
      size="120x120"
    ></app-img-display>
    <button
      mat-mini-fab
      class="white"
      appTooltip="Modifier l'avatar"
      (click)="updateAvatar()"
    >
      <mat-icon>create</mat-icon>
    </button>
    <button
      *ngIf="!hasDefaultAvatar"
      mat-mini-fab
      class="white"
      appTooltip="Supprimer l'avatar"
      (click)="deleteAvatar()"
    >
      <mat-icon>delete_forever</mat-icon>
    </button>
  </div>

  <div *ngIf="user && !user.emailValidated" class="text-white text-center m-3">
    <div class="mt-1">
      <mat-icon class="align-middle" color="warn">close</mat-icon> Votre adresse
      n'est pas vérifiée.
    </div>
    <div>
      A défaut de vérification sous quelques jours, votre compte sera suspendu.
    </div>
    <button
      class="align-middle mt-2"
      mat-flat-button
      type="button"
      color="primary"
      (click)="confirmSendValidationMail()"
      appTooltip="Envoyer le mail de vérification"
    >
      Vérifier
    </button>
  </div>
  <div
    *ngIf="externalManagedUser"
    class="text-white d-flex justify-content-center m-3"
  >
    <span>
      <mat-icon class="align-bottom mr-3" color="warn">warning</mat-icon>Votre
      compte est externe et n'est pas géré directement sur EEMO.
    </span>
  </div>

  <div class="row justify-content-around">
    <div *ngIf="user" class="col-12 col-xl-5">
      <app-card-base
        [title]="'Mon compte'"
        [hasSubmit]="canUpdatePassword"
        [hasFooter]="false"
        [submitText]="'Modifier mon mot de passe'"
        (onSubmitEvent)="updatePassword()"
        [loading]="false"
        [isDisabled]="externalManagedUser"
        [hasActionDivider]="true"
        [actionAlignment]="'end'"
      >
        <ng-container main *ngTemplateOutlet="contentMyAccount"></ng-container>
      </app-card-base>

      <ng-template #contentMyAccount>
        <div>
          <p>
            <span class="title">Email:</span
            ><span class="content"
              >{{ user.email }}
              <mat-icon
                *ngIf="user?.emailValidated"
                class="align-top"
                color="accent"
                matTooltip="Adresse email vérifiée"
                >check</mat-icon
              ><mat-icon
                *ngIf="!user?.emailValidated"
                class="align-top"
                color="warn"
                matTooltip="Adresse email non vérifiée"
                >close</mat-icon
              ></span
            >
          </p>
          <p>
            <span class="title">Type de compte:</span
            ><span class="content"
              >{{ "enum.UserRole." + user.role | translate }} -
              {{ "enum.AccountType." + user.accountType | translate }}</span
            >
          </p>
          <p *ngIf="currentUser.lastConnectionDate">
            <span class="title">Dernière connexion le:</span
            ><span class="content">{{
              currentUser.lastConnectionDate | dateTimeFormat
            }}</span>
          </p>
        </div>
      </ng-template>
    </div>

    <div *ngIf="user && !externalManagedUser" class="col-12 col-xl-5">
      <app-card-base
        [title]="'Mes informations'"
        [hasSubmit]="true"
        [hasFooter]="false"
        [submitText]="'Modifier'"
        (onSubmitEvent)="updateProfile()"
        [loading]="false"
        [isDisabled]="false"
        [hasActionDivider]="true"
        [actionAlignment]="'end'"
      >
        <ng-container main *ngTemplateOutlet="contentMyInfo"></ng-container>
      </app-card-base>

      <ng-template #contentMyInfo>
        <div>
          <p>
            <span class="title">Nom :</span
            ><span class="content">{{ user.firstName }} {{ user.name }}</span>
          </p>
          <p>
            <span class="title">Téléphone :</span
            ><span class="content">{{ user.phoneNumber }}</span>
          </p>
          <p>
            <span class="title">Adresse :</span
            ><span class="content">{{ addresseDisplay }}</span>
          </p>
          <p *ngIf="companyMainDisplay">
            <span class="title">{{ companyMainTitle }}:</span
            ><span class="content">{{ companyMainDisplay }}</span>
          </p>
          <p *ngIf="companyOthers">
            <span class="title">{{ companyOthersTitle }}:</span
            ><span class="content">
              <ul>
                <li *ngFor="let companyDisplay of companyOthers">
                  {{ companyDisplay }}
                </li>
              </ul>
            </span>
          </p>
        </div>
      </ng-template>
    </div>

    <div
      *ngIf="user && user.currentSubscription && canSeeSubscription"
      class="col-12 col-xl-5"
    >
      <app-card-base
        [title]="'Mon abonnement'"
        [hasSubmit]="!isOfferedPlan"
        [hasFooter]="false"
        [submitText]="
          canManageSubscription ? 'Gérer mon abonnement' : 'Voir les offres'
        "
        (onSubmitEvent)="onSubmitMySubscription()"
        [loading]="isRedirectingToStripeSubscription"
        [isDisabled]="false"
        [hasActionDivider]="true"
        [actionAlignment]="'end'"
      >
        <ng-container
          main
          *ngTemplateOutlet="contentMySubscription"
        ></ng-container>
      </app-card-base>

      <ng-template #contentMySubscription>
        <div>
          <p>
            <span class="title">Type:</span
            ><span class="content">{{ subscriptionPlanTypeName }}</span>
          </p>
          <p>
            <span class="title">État:</span
            ><span class="content"
              >{{
                "enum.SubscriptionState." + user.currentSubscription.state
                  | translate
              }}
              <mat-icon
                *ngIf="currentUserHasActiveSubscription"
                class="align-top"
                color="accent"
                matTooltip="Abonnement actif"
                >check</mat-icon
              ><mat-icon
                *ngIf="!currentUserHasActiveSubscription"
                class="align-top"
                color="warn"
                matTooltip="Abonnement non actif"
                >close</mat-icon
              ></span
            >
          </p>
          <p>
            <span class="title">Date de fin:</span
            ><span class="content">{{
              user.currentSubscription.dateEnd | dateFormat
            }}</span>
          </p>
        </div>
      </ng-template>
    </div>

    <div
      *ngIf="user && user.currentSubscription && canSeeSubscription"
      class="col-12 col-xl-5"
    >
      <app-card-base
        [title]="'Mes derniers paiements'"
        [hasSubmit]="true"
        [hasFooter]="false"
        [submitText]="'Voir plus'"
        (onSubmitEvent)="onSubmitMyPayments()"
        [loading]="isRedirectingToStripePayment"
        [isDisabled]="!canManageSubscription"
        [hasActionDivider]="true"
        [actionAlignment]="'end'"
      >
        <ng-container main *ngTemplateOutlet="contentMyPayment"></ng-container>
      </app-card-base>

      <ng-template #contentMyPayment>
        <div *ngIf="hasPayments; else noPayment">
          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let row" class="main mobile-inline">
                {{ row.date | dateTimeFormat }}
              </td>
            </ng-container>
            <ng-container matColumnDef="amountTaxIncl">
              <th mat-header-cell *matHeaderCellDef>Montant TTC</th>
              <td mat-cell *matCellDef="let row" class="main mobile-inline">
                {{
                  row.amountTaxIncl
                    | currency : "EUR" : "symbol" : "1.2-2" : "fr"
                }}
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td
                mat-cell
                *matCellDef="let row"
                class="no-mobile mobile-inline"
              >
                <mat-icon
                  *ngIf="row.isSuccess"
                  class="align-top"
                  color="accent"
                  matTooltip="Paiement effectué avec succès"
                  >check</mat-icon
                ><mat-icon
                  *ngIf="!row.isSuccess"
                  class="align-top"
                  color="warn"
                  matTooltip="Erreur de paiement"
                  >close</mat-icon
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Facture</th>
              <td mat-cell *matCellDef="let row" class="mobile-double-actions">
                <ng-container *ngIf="row.invoiceDocumentId">
                  <button
                    class="mobile-inline"
                    mat-icon-button
                    (click)="viewInvoice(invoices[row.invoiceDocumentId])"
                    appTooltip="Visualiser la facture"
                  >
                    <mat-icon color="primary">remove_red_eye</mat-icon>
                  </button>
                  <a
                    [href]="invoices[row.invoiceDocumentId]?.url"
                    [download]="invoices[row.invoiceDocumentId]?.filename"
                    appTooltip="Télécharger la facture"
                    ><mat-icon color="primary">cloud_download</mat-icon></a
                  >
                </ng-container>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </ng-template>

      <ng-template #noPayment>
        <div class="text-center">
          <p>&nbsp;</p>
          <p>Aucun paiement n'a encore été effectué.</p>
          <p>&nbsp;</p>
        </div>
      </ng-template>
    </div>

    <div *ngIf="preferences && canManagePreferences" class="col-12 col-xl-5">
      <app-card-base
        [title]="'Mes préférences'"
        [hasSubmit]="true"
        [hasFooter]="false"
        [submitText]="'Modifier'"
        (onSubmitEvent)="updatePreferences()"
        [loading]="false"
        [isDisabled]="false"
        [hasActionDivider]="true"
        [actionAlignment]="'end'"
      >
        <ng-container main *ngTemplateOutlet="contentMyPrefs"></ng-container>
      </app-card-base>

      <ng-template #contentMyPrefs>
        <div>
          <p>
            <span class="title">{{ "homeView" | translate }} :</span
            ><span class="content">{{
              "enum.HomeViewType." + preferences.homeView | translate
            }}</span>
          </p>
          <p>
            <span class="title">{{ "notificationSendMail" | translate }} :</span
            ><span class="content">{{
              (preferences.notificationSendMail ? "activated" : "deactivated")
                | translate
            }}</span>
          </p>
          <p>
            <span class="title"
              >{{ "notificationSendAppPush" | translate }} :</span
            ><span class="content">{{
              (preferences.notificationSendAppPush
                ? "activated"
                : "deactivated"
              ) | translate
            }}</span>
          </p>
          <p *ngIf="canSeeDefaultVisitModeType">
            <span class="title">{{ "defaultVisitModeType" | translate }} :</span
            ><span class="content">{{
              "enum.SharingVisitModeType." + preferences.defaultVisitModeType
                | translate
            }}</span>
          </p>
        </div>
      </ng-template>
    </div>

    <div *ngIf="user && !externalManagedUser" class="danger">
      <button
        mat-flat-button
        color="warn"
        (click)="
          canDeleteAccount ? deleteAccount() : infoActiveStripeSubscription()
        "
      >
        Supprimer mon compte
      </button>
    </div>
  </div>
</div>
